<!-- Toast overlay -->
<div *ngIf="showToastOverlay" class="toast-overlay"></div>

<!-- Toasts -->
<p-toast #global key="global-toast" position="center" [baseZIndex]="index" (onClose)="onClose($event)"></p-toast>
<p-toast #custom position="center" key="custom-toast" [baseZIndex]="index" class="custom-toast">
  <ng-template let-message pTemplate="message">
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-p-4">
      <span class="tw-w-full tw-font-bold tw-text-center tw-my-2" [ngClass]="{
          'tw-text-base': (getTranslatedSize(message.detail) | async) <= 60,
          'tw-text-sm': (getTranslatedSize(message.detail) | async) > 61 && (getTranslatedSize(message.detail) | async) <= 99,
          'tw-text-xs': (getTranslatedSize(message.detail) | async) > 100
        }">
        {{ message.detail | translate }}
      </span>
      <div class="tw-w-full tw-mt-4">
        <p-button styleClass="dialog-button" label="{{ 'Aceptar' | translate | uppercase }}"
          (onClick)="handleActionInToast(message)">
        </p-button>
      </div>
 
      <!-- Show details about trace id information -->
      <div class="tw-w-full">
        <div *ngIf="message?.data?.traceId" class="tw-w-full tw-flex tw-flex-col tw-mt-4">
          <div class="tw-w-full tw-flex tw-justify-end">
            <button type="button" class="tw-text-sm tw-text-gray-800 tw-flex tw-items-center"
              (click)="toggleTraceId(message.data.traceId)">
              {{ isTraceVisible(message.data.traceId) ? ('Ocultar detalles' | translate) : ('Mostrar detalles' |
              translate) }}
              <i [ngClass]="{
                'pi': true,
                'pi-chevron-up': isTraceVisible(message.data.traceId),
                'pi-chevron-down': !isTraceVisible(message.data.traceId),
                'tw-ml-1': true
              }"></i>
            </button>
          </div>
     
          <!-- traceid information data-->
          <div *ngIf="isTraceVisible(message.data.traceId)"
            class="tw-mt-2 tw-bg-red-50 tw-border-l-4 tw-border-red-400 tw-rounded-md tw-p-3 tw-text-xs tw-font-mono tw-w-full">
 
            <div class="tw-grid tw-grid-cols-3 tw-gap-x-1 tw-gap-y-1 tw-break-words">
              <div class="tw-font-semibold tw-text-gray-700">Código:</div>
              <div class="tw-col-span-2 tw-text-gray-800">{{ message.data.code }}</div>
           
              <div class="tw-font-semibold tw-text-gray-700">Path:</div>
              <div class="tw-col-span-2 tw-text-gray-800">{{ message.data.path }}</div>
           
              <div class="tw-font-semibold tw-text-gray-700">Trace ID:</div>
              <div class="tw-col-span-2 tw-text-gray-800">{{ message.data.traceId }}</div>
            </div>
          </div>
             
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<div class="tw-h-screen tw-flex tw-flex-col">
  <header class="tw-bg-black tw-w-screen tw-h-28 tw-flex-shrink-0 tw-flex tw-justify-center md:tw-justify-start tw-items-center tw-pt-[10px] tw-pb-[14px]">
    <a [routerLink]="''">
      <img class="md:tw-ml-[102px]" width="160px" height="64px" src="assets/img/logo.png" alt="Logo Mutua Borromeo Extendido">
    </a>
  </header>
  <main class="tw-flex-1">
    <router-outlet />
  </main>
</div>